<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  :items="categoryOptions"
                  item-text="Name"
                  item-value="ID"
                  label="假別"
                  v-model="form.Category"
                  :rules="formRules.Category"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.Reason"
                  rows="3"
                  label="原因"
                  :rules="formRules.Reason"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="代理人"
                  v-model="form.AgentID"
                  :rules="formRules.AgentID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <wwi-datetime-picker
                  v-model="form.Begin"
                  label="開始時間"
                >
                </wwi-datetime-picker>
              </v-col>
              <v-col cols="12">
                <wwi-datetime-picker
                  v-model="form.End"
                  label="結束時間"
                >
                </wwi-datetime-picker>
              </v-col>
              <!-- <span v-show="form.Category=='補休'">將扣除{{leaveDays}}天補休</span> -->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >送出</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {
      Begin: '',
      End: '',
    },
    defaultForm: {
      Name: "",
      Begin: '',
      End: '',
    }
  }),
  computed: {
    categoryOptions () {
      var hint = ''
      hint = `(尚有${this.totalHours/8}天補休)`
      return  [
        { ID: '事假', Name: "事假" },
        { ID: '病假', Name: "病假" },
        { ID: '生理假', Name: "生理假" },
        { ID: '特休', Name: "特休" },
        { ID: '補休', Name: `補休${hint}` },
        { ID: '曠職', Name: "曠職" },
        { ID: '其他', Name: "其他" }
      ]
    },
    formRules() {
      return {
        Category: [v => !!v || "請輸入名稱"],
        Reason: [v => !!v || "請輸入原因"],
        AgentID: [v => !!v || "請選擇代理人"],
        Begin: [v => !!v || "請輸入開始時間"],
        End: [v => !!v || "請輸入結束時間"]
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增" : "編輯";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.leaveForm.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    userOptions() {
      const findUserDepartment = user => {
        let departmentID = (
          this.userDepartments.find(o => o.UserID == user.ID) || {}
        ).DepartmentID;
        return this.departments.find(o => o.ID == departmentID) || {};
      };
      const findUserDepartmentID = user =>
        (this.userDepartments.find(o => o.UserID == user.ID) || {})
          .DepartmentID;
      return this.activeUsers
        .filter(o => o.ID != this.me.ID)
        .filter(o => AppDataSetting.findUserLevel(this, o) <= 10)
        // .filter(o => findUserDepartmentID(o) == this.myDepartment.ID)
        .map(o => ({ ID: o.ID, Name: `${o.Profile.Name} (${findUserDepartment(o).Name})` }));
    },
    totalHours () {
      return this.$store.state.compensatoryTime.list.reduce((sum,o)=>sum+((o.Status=='通過' || o.LeaveFormID > 0)?o.Hours : 0), 0)
    },
    // leaveDays () {
    //   if (!this.form.Begin) return 0
    //   if (!this.form.End) return 0
    //   let begin = moment(this.form.Begin)
    //   let end = moment(this.form.End)
    //   if (begin.isSame(end, "date")) {
    //     var duration = moment.duration(begin.diff(end));
    //     var hours = duration.asHours();
    //     if (hours==9)hours=8
    //     return Math.abs(hours/8)
    //   }
    //   // 1.
    //   var 第一天下班時間 = moment(begin).set({hour:18,minute:0,second:0,millisecond:0})
    //   // 如果開始時間，小於上班時間9點 / 大於下班時間6點 / 跨越中午時間12點....
    //   var firstDayHours = Math.abs(moment.duration(第一天下班時間.diff(begin)).asHours())

    //   var 最後一天上班時間 = moment(end).set({hour:9,minute:0,second:0,millisecond:0})
    //   // 如果結束時間，小於上班時間9點 / 大於下班時間6點 / 跨越中午時間12點....
    //   var lasatDayHours = Math.abs(moment.duration(end.diff(最後一天上班時間)).asHours())

    //   var allDays = Math.abs(end.diff(begin, 'days')) - 1
    //   if (allDays<0)allDays=0

    //   let days = parseInt((firstDayHours+lasatDayHours)/8)+allDays
    //   return days
    // },
    ...mapGetters([
      "activeUsers",
      "userPositions",
      "userDepartments",
      "me",
      "myDepartment",
      "departments"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      if (!this.form.Begin) return alert("請選擇開始時間");
      if (!this.form.End) return alert("請選擇結束時間");
      // if (this.form.Category == '補休' && this.totalHours < this.leaveDays*8) {
      //   if (!window.confirm(`您還有${this.totalHours/8}天補休，本次請假消耗${this.leaveDays}天補休，確定送出?`)) return
      // }

      if (moment(this.form.End) <= moment(this.form.Begin))
        return alert("錯誤: 結束時間必須大於開始時間");

      // this.form.Hours = parseInt(this.leaveDays*8)

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.leaveForm
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.leaveForm.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.leaveForm
          .add(this, this.form)
          .then(res => {
            this.$store.state.leaveForm.list.splice(0, 0, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        this.form = JSON.parse(
          JSON.stringify(this.$store.state.leaveForm.list[this.editingIdx])
        );
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.leaveForm.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>